import { usePunditUserContext } from "@circle-react/contexts";

export interface UseBrandedAppsBuilderFeatureFlagUIProps {
  isBrandedAppsBuilderUIEnabled: boolean;
  isDesignConfigEnabled: boolean;
  isOnPlusCustomPlan: boolean;
  isOrphanLinkConfigEnabled: boolean;
  isPreviewInsideBuilderEnabled: boolean;
  isWelcomePagesHomeTabsEnabled: boolean;
}

export const useBrandedAppsBuilderFeatureFlagUI =
  (): UseBrandedAppsBuilderFeatureFlagUIProps => {
    const { currentCommunitySettings, currentCommunity } =
      usePunditUserContext();

    const isBrandedAppsBuilderUIEnabled = Boolean(
      currentCommunitySettings?.branded_apps_builder_ui_enabled ||
        // custom_app_builder_feature_flag_enabled means that the community is in Plus Custom plan
        currentCommunity?.custom_app_builder_feature_flag_enabled,
    );

    const isDesignConfigEnabled = Boolean(
      currentCommunitySettings?.plus_design_config_enabled,
    );

    const isOrphanLinkConfigEnabled = Boolean(
      currentCommunitySettings?.plus_orphan_link_config_enabled,
    );

    const isWelcomePagesHomeTabsEnabled = Boolean(
      currentCommunitySettings?.welcome_page_home_tabs_enabled,
    );

    const isPreviewInsideBuilderEnabled = Boolean(
      currentCommunitySettings?.branded_mobile_app_builder_preview_enabled,
    );

    const isOnPlusCustomPlan = Boolean(
      currentCommunity?.custom_app_builder_feature_flag_enabled,
    );

    return {
      isBrandedAppsBuilderUIEnabled,
      isDesignConfigEnabled,
      isOrphanLinkConfigEnabled,
      isWelcomePagesHomeTabsEnabled,
      isPreviewInsideBuilderEnabled,
      isOnPlusCustomPlan,
    };
  };
